import * as Sentry from "@sentry/browser"
import fileDownload from "js-file-download"
import Config from "react-global-configuration"
import Axios from "axios"
import { useDeviceUtils } from "../../utils/useDeviceUtils"
import { createSafeFilename } from "../../utils/files"
import { useSnackbar } from "../../components/SnackbarProvider"

const defaultResult = { error: "Export failed, please try again later" }
const successResult = { message: "Success" }

// data = {job, organisation, location }
const useDownloadExportJob = () => {
  const { canPostMessage, postDownloadMessage } = useDeviceUtils()
  const snackbar = useSnackbar()

  const {
    clientKiosk: kiosk,
    clientDevice: device,
    services: {
      export: { jobUrl },
    },
  } = Config.get()

  const handleExportAndDownload = async (data) => {
    if ((kiosk || device) && !canPostMessage()) {
      snackbar.showMessage({ message: "Please download via desktop browser" })
      return
    }

    try {
      const response = await fetch(jobUrl, { method: "POST", body: JSON.stringify(data) })
      if (response.ok) {
        const json = await response.json()
        console.log("[SERVICES]", "Export job", json)

        const fileName = createSafeFilename(`${data.job.title}-${new Date().getTime()}`, "pdf")

        if (kiosk || device) {
          // handle on device
          // mock signed download - bit dodgy but works
          postDownloadMessage({
            signedDownloadUrl: json.url,
            upload: { fileName, contentType: "application/pdf" },
          })
          return successResult
        }

        const downloadResponse = await Axios({
          url: json.url,
          method: "GET",
          responseType: "blob",
        })

        fileDownload(downloadResponse.data, fileName)

        return successResult
      }
      Sentry.captureMessage(`Failed to export PDF for job '${data?.job?.id || "unknown id"}'`)
    } catch (error) {
      console.log("[SERVICES]", `Failed to fetch export job with error ${error.message}`)
      Sentry.captureException(error)
    }
    return { ...defaultResult }
  }

  return handleExportAndDownload
}

export { useDownloadExportJob }
